import styled from "styled-components";

import LabelSection from "src/components/core/LabelSection";
import Button from "src/components/core/Button";
import { Typography } from "@mui/material";
import Dropdown from "src/components/core/Dropdown";

import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { MoreHoriz, Edit } from "@mui/icons-material";

import { arrayMove } from "@dnd-kit/sortable";
import DraggableBoard, {
  DraggableItem,
} from "src/components/core/DraggableBoard";

// import BannerAddDialog from "./BannerAddDialog";

import { useDialog } from "src/context/DialogContext";

import font from "src/styles/font";
import { Black, DarkGrey, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import device from "src/styles/device";
import BannerAddDialog from "../Banner/BannerAddDialog";
import useBanner from "src/hooks/useBanner";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

// S.BannerListContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, 1fr);
//   gap: 16px;
// `;

// S.BannerItemWrapper = styled(DraggableItem)`
//   position: relative;
//   width: 100%;
//   padding-top: calc(100% / (1440 / 540));
//   background-color: #f3f1f2;
//   border-radius: 16px;
//   background-image: url(${(props) => props.$backgroundImage});
//   background-size: cover;
//   background-position: center;
// `;

S.HoverContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

S.ItemBackdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 16px;
`;

S.ItemActionMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 8px;
`;

S.BannerItemWrapper = styled(DraggableItem)``;

S.BannerItem = styled.div`
  width: 400px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  padding-top: 50%;

  @media ${device.tabletL} {
    width: 300px;
  }
`;

S.BannerItemContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

S.BannerListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

S.ImageBanner = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BrandPromotion = () => {
  const {
    banners: promotionBanners,
    setBanners: setPromotionBanners,
    addBanner: addPromotionBanner,
    fetchBanners: fetchPromotionBanners,
    updateBanner: updatePromotionBanner,
    updateBanners: updatePromotionBanners,
    toggleVisibility: toggleVisibilityPromotionBanners,
    // deleteBanner: deletePromotionBanner,
  } = useBanner({
    bannerKey: "brand_promotion",
    resource: "homepage",
  });

  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  return (
    <S.BoxWrapper>
      <LabelSection
        title="โปรเด็ดแบรนด์ดัง!"
        headerStyle={{
          marginBottom: 0,
        }}
      >
        <div
          style={{
            marginBlock: 32,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Typography
              style={{
                color: Black,
                fontSize: font.size.sm,
              }}
            >
              <strong>แบนเนอร์ :</strong> เพิ่มแบนเนอร์ได้สูงสุด 3 รูป ขนาดไฟล์
              400x200 px ไม่เกิน 4 MB
            </Typography>
            <Typography
              style={{
                color: DarkGrey,
                fontSize: font.size.sm,
              }}
            >
              คุณสามารถลากแบนเนอร์เพื่อสลับตำแหน่งได้
            </Typography>
          </div>
          <Button
            startIcon={<AddIcon />}
            variant="secondary"
            size="large"
            sx={{
              minWidth: 200,
            }}
            onClick={() => {
              openDialog({
                type: "custom",
                customDialog: (
                  <BannerAddDialog
                    onAddBanner={addPromotionBanner}
                    onClose={() => closeDialog()}
                    onSuccess={() => {
                      fetchPromotionBanners();
                      closeAllDialogs();
                    }}
                    dimension={{
                      width: 400,
                      height: 200,
                    }}
                  />
                ),
              });
            }}
            disabled={promotionBanners.length >= 3}
          >
            เพิ่มแบนเนอร์
          </Button>
        </div>
        <DraggableBoard
          items={promotionBanners}
          onDragEnd={async ({ active, over }) => {
            if (active.id !== over?.id) {
              const oldIndex = promotionBanners.findIndex(
                (item) => item._id === active.id,
              );
              const newIndex = promotionBanners.findIndex(
                (item) => item._id === over.id,
              );

              const newReArranged = arrayMove(
                promotionBanners,
                oldIndex,
                newIndex,
              );

              setPromotionBanners(newReArranged); // optimistic update

              try {
                await updatePromotionBanners(newReArranged);
              } catch (err) {
                setPromotionBanners(promotionBanners); // if error, revert to original order
                console.error(err);
              }
            }
          }}
          Components={{
            DroppableParent: ({ items, children }) => {
              return (
                <S.BannerListContainer>
                  {children({ items })}
                </S.BannerListContainer>
              );
            },
            DraggableItem: (props) => {
              const { item, items, ...rest } = props; // Destructuring items to prevent this spreading to html element
              return (
                <S.BannerItemWrapper {...rest}>
                  <S.BannerItem>
                    <S.BannerItemContent>
                      <S.ImageBanner src={item?.image} alt="" />
                    </S.BannerItemContent>
                    {!item?.is_public && (
                      <S.ItemBackdrop>
                        <VisibilityOffIcon
                          sx={{
                            color: White,
                          }}
                        />
                      </S.ItemBackdrop>
                    )}
                    <S.HoverContainer>
                      {item?.is_public && <S.ItemBackdrop />}
                      <S.ItemActionMenu>
                        <Dropdown
                          renderButton={(props) => (
                            <IconButton
                              sx={{
                                color: White,
                                backgroundColor: hexToRgba(White, 0.4),
                              }}
                              {...props}
                            >
                              <MoreHoriz />
                            </IconButton>
                          )}
                          options={[
                            {
                              label: "แก้ไข",
                              startIcon: <Edit />,
                              onClick: () => {
                                openDialog({
                                  type: "custom",
                                  customDialog: (
                                    <BannerAddDialog
                                      initialValue={item}
                                      onUpdateBanner={updatePromotionBanner}
                                      onClose={() => closeDialog()}
                                      onSuccess={() => {
                                        fetchPromotionBanners();
                                        closeAllDialogs();
                                      }}
                                      dimension={{
                                        width: 400,
                                        height: 200,
                                      }}
                                    />
                                  ),
                                });
                              },
                            },
                            {
                              label: item?.is_public ? "ซ่อน" : "แสดง",
                              startIcon: item?.is_public ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              ),
                              onClick: () => {
                                openDialog({
                                  type: "confirm",
                                  title: `คุณต้องการ${
                                    item?.is_public ? "ปิด" : "เปิด"
                                  }การมองเห็นใช่หรือไม่?`,
                                  onConfirm: async () => {
                                    await toggleVisibilityPromotionBanners(
                                      item?.position,
                                    );
                                    fetchPromotionBanners();
                                  },
                                  maxWidth: 342,
                                });
                              },
                            },
                            // {
                            //   label: "ลบ",
                            //   startIcon: <DeleteOutlineRoundedIcon />,
                            //   onClick: () => {
                            //     openDialog({
                            //       type: "confirm",
                            //       title: "คุณต้องการลบใช่หรือไม่?",
                            //       onConfirm: async () => {
                            //         await deletePromotionBanner(item?.position);
                            //         fetchPromotionBanners();
                            //       },
                            //       maxWidth: 342,
                            //     });
                            //   },
                            // },
                          ]}
                        />
                      </S.ItemActionMenu>
                    </S.HoverContainer>
                  </S.BannerItem>
                </S.BannerItemWrapper>
              );
            },
          }}
        />
        {/* <Typography
          sx={{
            mt: 3,
            alignSelf: "center",
            fontSize: font.size.sm,
            color: DarkGrey,
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <InfoRounded
            sx={{
              color: Yellow,
              mr: 0.5,
            }}
          />{" "}
          เพิ่มแบนเนอร์ได้สูงสุด 12 รูป ขนาดไฟล์ 1440x540 px ไม่เกิน 4 MB
        </Typography> */}
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default BrandPromotion;
